import { useQuery } from '@tanstack/react-query';

import * as api from 'apis/merchant-onboarding-service/api';

import { getMacSigneeInformation } from '../../../apis/merchant-access-control/api';

const useSigneeInformation = (onboardingToken?: string | null) => {
  const { data, isFetching, isError } = useQuery(
    ['merchant-sign-up'],
    () => api.getSigneeInformation(onboardingToken!),
    {
      enabled: !!onboardingToken,
      staleTime: Infinity,
    },
  );
  return { data, isFetching, isError };
};

export default useSigneeInformation;

// Similar to useSigneeInformation but query against a merchant-access-control (MAC) endpoint
const useMacSigneeInformation = (onboardingToken?: string | null) => {
  const { data, isFetching, isError } = useQuery(
    ['mac-user-sign-up'],
    () => getMacSigneeInformation(onboardingToken!),
    {
      enabled: !!onboardingToken,
      staleTime: Infinity,
    },
  );
  return { data, isFetching, isError };
};

export { useMacSigneeInformation };
